import React, { Component } from "react";
import './Music-List.css';
import axios from '../tokenInterceptor';
import { createBrowserHistory } from 'history';
import Home from "./Home";


class Login extends React.Component {


     amamzonSignIn = () => {
        var options = {
            "scope" :  ['profile', 'amazon_music:access'],
            "popup": true,
            "response_type": 'code'
        };

        console.log('*************** in amamzonSignIn', options);


        // var data =
        window.amazon.Login.authorize(options, (response) => {
            console.log('*************** got response from Amamzon Login', response)
            console.log(response);
            if (response.error) {
                console.log('oauth error ' + response.error);
                return;
            }
            var requestObject = {
                "grant_type": "authorization_code",
                "code": response.code,
                "client_id": "amzn1.application-oa2-client.be6fd65f44a24c7dabec6f1e78c0fbd9",
                "client_secret": "9ceb5c037d0d032d62fd09e64b4784dfd06ec22cae72e15cb9b9e1690e3bfe05"
            };

             axios.post("https://api.amazon.com/auth/o2/token", requestObject).then((res) => {
                  if (res.status === 200) {
                    console.log("responsereceived ===== ", res);
                    var currentTime = new Date();
                    this.tokenGetTime = currentTime.getTime();
                    localStorage.setItem('auth-token', res.data.access_token);
                    localStorage.setItem('expire', 3600);
                    localStorage.setItem('tokenFetchTime', this.tokenGetTime);
                    localStorage.setItem('refresh_token', res.data.refresh_token);
                    // this.getMostPopularList();
                    this.props.history.push('/chart');

                } else {
                    console.log("unable to generate token");
                }});
            /*if ( response.error ) {
                alert('oauth error ' + response.error);
                return;
            }
            alert('success: ' + response.access_token);*/

        });
        // console.log("data---", data)
    }

    render() {

        return (
            <div>
                <a href id="LoginWithAmazon">
                <img
                 style={{width: "156", height:"32", resizeMode : 'stretch', border: "0" }}
                 src="http://g-ecx.images-amazon.com/images/G/01/lwa/btnLWA_gold_156x32.png" alt="Login with Amazon" onClick={() => this.amamzonSignIn()}
                />
                </a>
            </div>
        );
    }
}

// class Login extends Component() {
    // constructor() {
    //     super(props);
    //     this.state = {}
    // }
    //
    // myMethod() {
    //     var options = {
    //         "scope" : 'profile',
    //         "popup": true
    //     };
    //     var data = amazon.Login.authorize(options, 'https://www.ipapp.com/handle_login.php');
    //     console.log("data---", data)
    // }
    //
    // generateNewAccessToken = () => {
    //     let that = this;
    //     var options = {
    //         "scope": ['profile', 'amazon_music:access'],
    //         "popup": true,
    //         "response_type": 'code'
    //     };
    //     amazon.Login.authorize(options, function (response) {
    //         if (response.error) {
    //             console.log('oauth error ' + response.error);
    //             return;
    //         }
    //         console.log(response);
    //
    //         var requestObject = {
    //             "grant_type": "authorization_code",
    //             "code": response.code,
    //             "client_id": "amzn1.application-oa2-client.be6fd65f44a24c7dabec6f1e78c0fbd9",
    //             "client_secret": "9ceb5c037d0d032d62fd09e64b4784dfd06ec22cae72e15cb9b9e1690e3bfe05"
    //         };
    //         // axios.post("https://api.amazon.com/auth/o2/token", requestObject).then((res) => {
    //         //     if (res.status === 200) {
    //         //         console.log("responsereceived == ", res);
    //         //         var currentTime = new Date();
    //         //         this.tokenGetTime = currentTime.getTime();
    //         //         localStorage.setItem('auth-token', res.data.data.access_token);
    //         //         localStorage.setItem('expire', 3600);
    //         //         localStorage.setItem('tokenFetchTime', this.tokenGetTime);
    //         //         localStorage.setItem('refresh_token', res.data.data.refresh_token);
    //         //         this.getMostPopularList();
    //         //     } else {
    //         //         console.log("unable to generate token");
    //         //     }
    //             that.musicDetailService.getAccessToken(requestObject).subscribe((res) => {
    //                 localStorage.setItem("auth-token", res.access_token);
    //                 that.getMusicEvent();
    //                 console.log("refresh-token " + res.refresh_token);
    //                 console.log("access_token " + res.access_token);
    //                 console.log("refresh-token " + res.refresh_token);
    //                 amazon.Login.retrieveProfile(res.access_token, function (response) {
    //                     console.log('Hello, ' + response.profile.Name);
    //                     console.log('Your e-mail address is ' + response.profile.PrimaryEmail);
    //                     console.log('Your unique ID is ' + response.profile.CustomerId);
    //                 });
    //             })
    //
    //         });
    //
    //     render()
    //     {
    //         return <h1>Hello</h1>
    //
    //     }
    //
    // }

// }

export default Login;



